import React from "react";
import PropTypes from "prop-types";
import {componentMap} from '../../../util/componentMap';
import Prism from 'prismjs';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-python';
import 'prismjs/themes/prism.css';

class DynamicHTMLComponent extends React.Component {

  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    this.highlightCode();
  }

  componentDidUpdate() {
    this.highlightCode();
  }

  highlightCode() {
    if (this.containerRef.current) {
      setTimeout(() => Prism.highlightAllUnder(this.containerRef.current), 0);
    }
  }

  getStartTag = (component, classNames, contentBaseURL) => {
    const tag = componentMap[component];
    const classes = classNames ? classNames : "";
    if (tag) {
      if(tag === "img") {
        return "<img src=\""+ contentBaseURL + "img/";
      }

      if (tag === "html") {
        return "<iframe id=\"dynamicHTMLContentId\" class=\"iframeContent\" onload=\"adjustHeight();\" src=\"" + contentBaseURL +"html/";
      }

      return "<" + tag + " class=\"" + classes + "\">";
    }
    return "<p class=\"" + classes + "\">"
  }

  getEndTag = (component) => {
    const tag = componentMap[component];
    if (tag) {
      if(tag === "img"){
        return "\"/>";
      }

      if (tag === "html"){
        return "\">";
      }

      return "</" + tag + ">"
    }
    return "</p>";
  }

  getComponentToRender = (content, contentBaseURL) => {
    if (content.dataList) {
      const items = content.dataList.map(item => this.getComponentToRender(item, contentBaseURL)).join('');
      return this.getStartTag(content.component, content.classNames, contentBaseURL) + items + this.getEndTag(content.component);
    } else if (Array.isArray(content.data)) {
      if (content.component === 'ul') {
        const items = content.data.map(item => `<li>${item}</li>`).join('');
        return this.getStartTag(content.component, content.classNames, contentBaseURL) + items + this.getEndTag(content.component);
      } else {
        return this.getStartTag(content.component, content.classNames, contentBaseURL) + content.data.join('') + this.getEndTag(content.component);
      }
    } else {
      return this.getStartTag(content.component, content.classNames, contentBaseURL) + (content.data || '') + this.getEndTag(content.component);
    }
  }

  render(){
    const {content, contentBaseURL} = this.props;
    const DynamicComponent= this.getComponentToRender(content, contentBaseURL);
    return (
        <>
          {content &&
            <div ref={this.containerRef} dangerouslySetInnerHTML={{ __html: DynamicComponent }} />
          }
        </>
      )
    }
}

DynamicHTMLComponent.propTypes = {
  content:PropTypes.object,
  contentBaseURL:PropTypes.string
};

export default DynamicHTMLComponent;
